module.exports = {"id":"199238","name":"Yun Young Sun","rating":"74","photo":"./data/images/photos/1/199238.png","club":{"name":"Sangju Sangmu","logo":"./data/images/clubs/SangjuSangmu.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YunYoungSun0.json
// module id = 4440
// module chunks = 0